import { useState, useRef, useEffect } from 'react';
import { ArrowIcon, CheckboxCheckedIcon, CheckboxUncheckedIcon } from '../../assets/icons/Icons';

const FilterPopup = ({
  data,
  onApply,
  selectedOrders,
  setSelectedOrders,
  selectedSatellites,
  setSelectedSatellites,
  satelliteNames,
  orderNames,
  groundStationNames = [],
  selectedGroundStations = [],
  setSelectedGroundStations,
}) => {

  const [showSatelliteList, setShowSatelliteList] = useState(false);
  const [showOrderList, setShowOrderList] = useState(false);
  const [showGroundStationList, setShowGroundStationList] = useState(false);

  const [filteredItems, setFilteredItems] = useState([]);

  const satelliteRef = useRef();
  const orderRef = useRef();
  const groundStationRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        satelliteRef.current && !satelliteRef.current.contains(e.target) &&
        orderRef.current && !orderRef.current.contains(e.target) &&
        (!groundStationRef.current || !groundStationRef.current.contains(e.target))
      ) {
        setShowSatelliteList(false);
        setShowOrderList(false);
        setShowGroundStationList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const result = data.filter(item => {
      const satelliteName = item?.data?.satellite?.name;

      const itemOrderNames = item?.type === 'Order'
        ? [item?.data?.orderSummary?.orderName]
        : item?.type === 'Ground'
          ? (item?.data?.downlinkOrders || []).map(order => order?.orderName)
          : [];

      const gsName = item?.data?.groundStation?.name;

      const satelliteMatch = selectedSatellites.includes(satelliteName);
      const orderMatch = itemOrderNames.some(orderName => selectedOrders.includes(orderName));
      const groundStationMatch = item?.type === 'Ground' && groundStationNames.length > 0
        ? selectedGroundStations.includes(gsName)
        : true;

      return satelliteMatch && orderMatch && groundStationMatch;
    });
    setFilteredItems(result);
  }, [selectedSatellites, selectedOrders, selectedGroundStations, data]);

  const toggleSelection = (value, selectedList, setSelectedList) => {
    if (selectedList.includes(value)) {
      setSelectedList(selectedList.filter(item => item !== value));
    } else {
      setSelectedList([...selectedList, value]);
    }
  };

  const handleReset = () => {
    // RESET TO SHOW ALL
    setSelectedSatellites(satelliteNames);
    setSelectedOrders(orderNames);
    if (setSelectedGroundStations) setSelectedGroundStations(groundStationNames);
    setFilteredItems(data);
    onApply(data);
  };

  const handleApply = () => {
    onApply(filteredItems);
  };

  return (
    <div className="filter-popup">
      <div className="filter-header">
        <span className='filter-header-text'>Filters</span>
      </div>
      <div className="filter-labels">
        <div className="filter-type" onClick={() => setShowSatelliteList(!showSatelliteList)}>
          <div className='filter-type-label'>Satellite</div>
          <div><ArrowIcon /></div>
        </div>
        <div className="filter-type" onClick={() => setShowOrderList(!showOrderList)}>
          <div className='filter-type-label'>Orders</div>
          <div><ArrowIcon /></div>
        </div>
        {groundStationNames.length > 0 && (
          <div className="filter-type" onClick={() => setShowGroundStationList(!showGroundStationList)}>
            <div className='filter-type-label'>Ground Stations</div>
            <div><ArrowIcon /></div>
          </div>
        )}
      </div>

      {showSatelliteList && (
        <div className="popup-list" ref={satelliteRef}>
          <div className='popup-title'>Satellites</div>
          {satelliteNames.map((name, idx) => (
            <div className='popup-item' key={idx} onClick={() => toggleSelection(name, selectedSatellites, setSelectedSatellites)}>
              {selectedSatellites.includes(name) ? (<CheckboxCheckedIcon />) : (<CheckboxUncheckedIcon />)}
              {name}
            </div>
          ))}
        </div>
      )}

      {showOrderList && (
        <div className="popup-list" ref={orderRef}>
          <div className='popup-title'>Orders</div>
          {orderNames.map((name, idx) => (
            <div className='popup-item' key={idx} onClick={() => toggleSelection(name, selectedOrders, setSelectedOrders)}>
              {selectedOrders.includes(name) ? (<CheckboxCheckedIcon />) : (<CheckboxUncheckedIcon />)}
              {name}
            </div>
          ))}
        </div>
      )}

      {showGroundStationList && setSelectedGroundStations && (
        <div className="popup-list" ref={groundStationRef}>
          <div className='popup-title'>Ground Stations</div>
          {groundStationNames.map((name, idx) => (
            <div className='popup-item' key={idx} onClick={() => toggleSelection(name, selectedGroundStations, setSelectedGroundStations)}>
              {selectedGroundStations.includes(name) ? (<CheckboxCheckedIcon />) : (<CheckboxUncheckedIcon />)}
              {name}
            </div>
          ))}
        </div>
      )}

      <div className='filter-footer'>
        <button
          className='filter-btn filter-clear-button ps-btn-dark'
          onClick={handleReset}
        >
          Reset
        </button>
        <button
          className='filter-btn filter-apply-button ps-btn-light'
          onClick={handleApply}
        >
          Apply
        </button>
      </div>

    </div>
  );
};

export default FilterPopup;
